import { Flex, FlexProps, spacing } from 'deepstash-ui';
import React from 'react';
import { GAP_SIZE_REM } from 'utils/global';

export interface FullWidthScrollableWrapperProps {
  children?: React.ReactNode;
}

const FullWidthScrollableWrapper = React.forwardRef<
  HTMLDivElement | null,
  FullWidthScrollableWrapperProps & FlexProps
>(({ children, ...props }, ref) => {
  return (
    <Flex
      gridGap={GAP_SIZE_REM}
      justifyContent="left"
      width="100%"
      px={{
        base: GAP_SIZE_REM,
        md: 'calc(50vw - 368px)',
        lg: 'calc(50vw - 560px)',
      }}
      overflowX="scroll"
      alignItems="flex-start"
      ref={ref}
      pb={spacing.M.px}
      {...props}
    >
      {children}
    </Flex>
  );
});

export default FullWidthScrollableWrapper;
